$(document).ready(function() {

    $('.menu .menuitem').on('click', function() {

        $(this).closest('.menu').find('ul li ul').hide();
        $(this).closest('li').siblings().removeClass('selected');
        $(this).closest('li').addClass('selected');

        $(this).closest('li').find('ul').show();
    });

});
